import { GET_REASON_BY_ACTIONS, GET_REASON_BY_ACTIONS_SUCCESS, GET_REASON_BY_ACTIONS_ERROR, GET_REASON_BY_ACTIONS_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetReasonByActions = (state = initialState, action) => {
  switch (action.type) {
    case GET_REASON_BY_ACTIONS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_REASON_BY_ACTIONS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_REASON_BY_ACTIONS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_REASON_BY_ACTIONS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetReasonByActions;
